import { BoardColumnMap, IBoardItem } from '../../../shared/Board/types/BoardColumn';

export function boardCalcDataLength<T>(columns: BoardColumnMap<IBoardItem>) {
    return Object.values(columns)
        .map((item) => item.items.length)
        .reduce((accumulator, currentValue) => accumulator + currentValue);
}
